
namespace Matrix.Data {
    @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerClass()
    export class SecurityRepairLogGrid extends SiteEntityGrid<SecurityRepairLogRow, any> {
        protected getColumnsKey() { return 'Data.SecurityRepairLog'; }
        protected getDialogType() { return SecurityRepairLogDialog; }
        protected getIdProperty() { return SecurityRepairLogRow.idProperty; }
        protected getInsertPermission() { return SecurityRepairLogRow.insertPermission; }
        protected getLocalTextPrefix() { return SecurityRepairLogRow.localTextPrefix; }
        protected getService() { return SecurityRepairLogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            var sc = Q.tryFirst(filters, x => x.field == "StatusCode") as Serenity.QuickFilter<SecurityRepairStatusEditor, any>;
            if (sc)
                sc.init = w => w.value = "PENDING";

            return filters;
        }

        protected getButtons() {
            var buttons = super.getButtons().filter(x => x.cssClass != "add-button");
            return buttons;
        }
    }
}